export default __webpack_public_path__ + "static/media/Group8922.270508ad.svg";